import { DateTime } from 'luxon'

export function formatForServer(
    date: DateTime,
    timeZoneId: string | undefined = undefined,
): string {
    return date.set({ millisecond: 0 }).setZone(timeZoneId, { keepLocalTime: true }).toUTC().toISO({ suppressMilliseconds: true })
}